import { render, staticRenderFns } from "./Rows.vue?vue&type=template&id=39faedda&"
import script from "./Rows.vue?vue&type=script&lang=js&"
export * from "./Rows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports